<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="modal-title font-weight-bold">UPDATE CURRICULUM</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div
          style="position: relative; top: -10px; margin-bottom: -8px"
          v-if="show_processing"
        >
          <div
            class="
              display-processing
              color_white_bg
              rounded-5
              w-100
              d-flex
              justify-content-start
              align-items-center
              mb-3
              p-2
            "
          >
            <div class="avatar">
              <span
                class="font-20 brand_accent flex-center mr-2"
                :class="alert_icon"
              ></span>
            </div>
            <div class="text color_grey_dark font-14">{{ alert_text }}</div>
          </div>
        </div>

        <form action>
          <div class="curriculum-text font-13-5 color_grey_dark mb-4">
            Your default curriculum is used to suggest questions to your
            teachers
          </div>

          <div class="container curriculum-preference mb-4 px-1">
            <!-- Curriculum -->
            <div
              class="preference-card"
              v-for="(curriculum, index) in curriculum_list"
              :key="index"
            >
              <div class="">
                <label
                  :for="curriculum.slug"
                  class="label radio"
                  :class="
                    curriculum_selected === curriculum.title
                      ? 'label-active'
                      : null
                  "
                >
                  <!-- INPUT -->
                  <input
                    type="radio"
                    :id="curriculum.slug"
                    :value="curriculum.title"
                    v-model="curriculum_selected"
                    @change="onChecked($event, curriculum.id, curriculum.title)"
                  />
                  <!-- TEXT CONTENT -->
                  <div class="text-content">
                    <div class="title">
                      {{
                        curriculum.title === "Nigeria"
                          ? "Nigerian"
                          : curriculum.title
                      }}
                      Curriculum
                    </div>
                    <div class="description">{{ curriculum.description }}</div>
                  </div>
                </label>
              </div>
            </div>
            <!-- Curriculum -->

            <!-- CREATE CUSTOM CURRICULUM -->
            <div class="preference-card" v-if="!curriculum_list.length > 2">
              <div class="">
                <label class="label" @click="$emit('toggleRequestModal')">
                  <!-- AVATAR -->
                  <div class="avatar mr-3" style="margin-left: -3px">
                    <span
                      class="icon-file-plus brand_accent font-22 flex-center"
                    ></span>
                  </div>
                  <!-- TEXT CONTENT -->
                  <div class="text-content">
                    <div class="title">Create your own</div>
                    <div class="description">
                      Have a special curriculum, and would like to set it up.
                      Click here to Set up a custom curriculum.
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <!-- CREATE CUSTOM CURRICULUM -->
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "CurriculumRequestModal",

  components: {
    Modal,
  },

  props: {
    curriculum_list: Array,
    active_curriculum: String,
  },

  data() {
    return {
      curriculum_selected: this.active_curriculum,
      show_processing: false,
      alert_icon: "icon-dotted-roller animate",
      alert_text: "Updating curriculum, please wait...",
    };
  },

  mounted() {},

  methods: {
    ...mapActions(["updateCurriculum"]),

    onChecked($event, curriculum_id, curriculum_title) {
      this.show_processing = true;
      $event.target.checked
        ? $event.target.parentElement.classList.add("label-active")
        : $event.target.parentElement.classList.remove("label-active");

      this.curriculum_selected = curriculum_title;

      this.updateCurriculum(Number(curriculum_id))
        .then((response) => {
          if (response.code === 200) {
            setTimeout(() => {
              this.alert_icon = "icon-accept";
              this.alert_text = "Updated";
            }, 2000);

            setTimeout(() => {
              let dialog_data = {
                msg: "Curriculum list updated successfully!",
                type: "success",
              };
              this.$emit("showAlertCard", dialog_data);
              this.$emit("closeTriggered");
            }, 4000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
}

.curriculum-text {
  @include breakpoint_max(sm) {
    font-size: 12.5px !important;
    line-height: 22px;
  }
}

.curriculum-preference {
  .preference-card {
    width: 100%;

    @include breakpoint_max(lg) {
      width: 100%;
    }

    .label {
      @include flex_row_start_nowrap;
      align-items: flex-start;
      border: 1px solid $border_grey;
      background: #ffffff;
      box-sizing: border-box;
      padding: 18px 22px 14px;
      border-radius: 5px;
      width: 100%;
      height: 100%;
      margin-bottom: 10px;
      cursor: pointer;

      @include breakpoint_max(sm) {
        padding: 14px;
      }

      &-sm {
        padding: 12px 22px 8px;

        @include breakpoint_max(sm) {
          padding: 18px 18px 8px;
        }
      }

      input {
        margin-right: 12px;
        margin-top: 4.5px;

        @include breakpoint_max(sm) {
          margin-right: 6px;
          margin-top: 7px;
        }
      }

      .title {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: $color_text;
        margin-bottom: 10px;
        text-transform: capitalize;

        @include breakpoint_max(lg) {
          font-size: 14.5px;
        }

        @include breakpoint_max(sm) {
          font-size: 13px;
          line-height: 18px;
          margin-bottom: 2px;
        }

        &-sm {
          margin-top: 2.5px;
          font-size: 14.5px;

          @include breakpoint_max(lg) {
            font-size: 14px;
          }
        }
      }

      .description {
        font-size: 12.5px;
        line-height: 18.5px;
        color: $color_grey_dark;

        @include breakpoint_max(lg) {
          font-size: 11.5px;
        }

        @include breakpoint_max(sm) {
          font-size: 11px;
        }
      }

      &-active {
        border: 1px solid $brand_accent;
      }
    }
  }

  .preference-request {
    @include flex_row_start_nowrap;
    align-items: flex-start;
    width: 470px;
    background: #ffffff;
    border: 1px dashed $border_grey_dark;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 19px;
    color: $color_text;
    padding: 10px 22px;
    margin-top: 20px;
    margin-bottom: 60px;

    @include breakpoint_max(lg) {
      width: 100%;
      font-size: 13px;
    }

    .icon {
      font-size: 24px;
      color: $border_grey_dark;
      margin-right: 10px;

      @include breakpoint_max(lg) {
        font-size: 22px;
      }
    }

    .help-text {
      margin-top: 2px;
    }
  }
}
</style>
